import axios from "axios";
import { BASE_API } from "./entities";

export async function get_route_subscriptions_from_bb(getstate) {
  const isUserPresent =
    getstate()?.route?.USER_DETAILS?.webuser?.userid != null;
  const entity_id = getstate()?.route?.USER_DETAILS?.id;
  let jwt_token;
  if (isUserPresent) {
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  } else {
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN;
  }
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: isUserPresent && "663ccc4949374185a89fddfcd53e19cf",
      input: {
        entityId: entity_id,
        skip: 0,
        take: 200,
      },
    },
  };

  return axios.post(BASE_API, query, { headers }).then(async (result) => {
    if (
      result?.data?.data &&
      result?.data?.data?.action &&
      result?.data?.data?.action?.results
    ) {
      let filteredData = result?.data?.data?.action?.results || [];
      let allCount = result?.data?.data?.action?.results?.length || 0;
      return [200, filteredData, allCount];
    } else if (result?.data?.errors || result?.data?.data?.errors) {
      const errMsg =
        result.data.errors[0].message || result.data.data.errors[0].message;
      console.error(errMsg);
    }
    return [200, [], 0];
  });
}

export async function addRouteSubscription(payload, getstate) {
  // console.log("addRouteSubscription is executing.........", payload);
  const isUserPresent =
      getstate()?.route?.USER_DETAILS?.webuser?.userid != null;
  const entity_id = getstate()?.route?.USER_DETAILS?.id;
  if (!entity_id) return false;
  // console.log("rateProfileId: ",rateProfileId,"isUserPresent: ",isUserPresent)
  let jwt_token;
  if (isUserPresent) {
      jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  } else {
      jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN;
  }
  const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt_token + "",
  };

  let query = {
      query: "mutation { action(id: $action_id input: $input)}",
      variables: {
      action_id: isUserPresent && "512189bfcae34e49819634558277760c",
      input: {
          carrier: Number(payload?.carrier),
          destination: Number(payload?.destinationPort),
          discharge: Number(payload?.dischargePort),
          isNewRoute: payload?.newRoute,
          origin: Number(payload?.originPort),
          routeSubscriptionId: payload?.routeSubscriptionId,
          entityId: Number(entity_id),
          // fakPercentage: payload?.fakPercentage || 50,
          // nacPercentage: payload?.nacPercentage || 50,
          isFcl: payload?.isFcl,
          isLcl: payload?.isLcl,
      },
      },
  };

  let result = [false];

  try {
      const response = await axios.post(BASE_API, query, { headers });
      // console.log("response: ",response)
      if (
      response?.data?.data?.action?.results ||
      response?.data?.data?.action?.results === ""
      ) {
      result = [true, response?.data?.data?.action?.results];
      } else if (result?.data?.errors || result?.data?.data?.errors) {
      const errMsg =
          result.data.errors[0].message || result.data.data.errors[0].message;
      console.error(errMsg);
      }
  } catch (error) {
      console.error(`error: ${error}`);
  }
  // console.log("----result---------", result);
  return result;
}

export async function deleteRouteSubscription(id, getstate) {
  // console.log("----delete subscription-----------",id)
  const isUserPresent =
      getstate()?.route?.USER_DETAILS?.webuser?.userid != null;
  let jwt_token;
  if (isUserPresent) {
      jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  } else {
      jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN;
  }
  const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt_token + "",
  };

      let query = {
      query: "mutation { action(id: $action_id input: $input)}",
      variables: {
      action_id: isUserPresent && "d36715c7de6d488eabdaf7005e0164c2",
      input: {
          routeSubscriptionId: id
      },
      },
  };

  let result = [false];

  try {
      const response = await axios.post(BASE_API, query, { headers });
      if (
      response?.data?.data?.action?.results ||
      response?.data?.data?.action?.results === ""
      ) {
      result = [true, response?.data?.data?.action?.results];
      }
  } catch (error) {
      console.error(`error: ${error}`);
  }
  // console.log("result: ",result)
  return result;
}
